import * as wv from '../global/worldvision.js';
import { PageKind } from '../page/vars.js';

export function initialize(global, page_vars) {
    let url_params = wv.get_obj(global, 'url_params') || {};

    if (page_vars === undefined || !is_sponsorship_from_eventsapp(page_vars)) {
        return;
    }

    let mot_code = url_params.mc;
    let vendor_id = url_params.vendorid;
    let rep_id = url_params.repid;

    if (mot_code) {
        create_message('mc', mot_code);
    }
    if (vendor_id) {
        create_message('vendorid', vendor_id);
    }
    if (rep_id) {
        create_message('repid', rep_id);
    }
}

function is_sponsorship_from_eventsapp(page_vars) {
    return page_vars.kind === PageKind.EventsApp;
}

function create_message(id, value) {
    let append_info_id = id;
    let append_info_value = value;
    let append_info_template = `<input id='${append_info_id}Input' type='hidden' name='properties[${append_info_id}]' value='${append_info_value}'>`;
    let sponsorship_form = document.getElementById('sponsorbtn-form');
    if (sponsorship_form !== null) {
        sponsorship_form.append(append_info_template);
    }
}
